// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.uploader__main {
  width: 100%;
  height: 280px;
  display: flex;
  justify-content: space-between;
  position: relative;
  background-color: #fff;
  overflow: hidden;
}

.uploader__main__loader {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #fff;
  z-index: 10;
  display: flex;
  justify-content: center;
  align-items: center;
  display: none;
}

.uploader__main__loader.visible {
  display: flex;
}

.uploader__main__dropper {
  width: 60%;
  height: 100%;
  border: 1px dashed rgb(208, 208, 208);
  border-radius: 5px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}

.uploader__main__dropper__container {
  padding: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  pointer-events: none;
}

.uploader__main__dropper__container.enable {
  pointer-events: all;
}

.uploader__main__sample {
  width: 150.4px;
  height: auto;
}

.uploader__main__sample__image {
  height: 145.6px;
  width: 150.4px;
  overflow: hidden;
}

.uploader__main__sample__image img {
  width: 100%;
}

.uploader__bottom {
  width: 100%;
  height: 60px;
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
}
`, "",{"version":3,"sources":["webpack://./src/components/imageUploader/imageSelector/ImageSelector.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,aAAa;EACb,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,qBAAqB;AACvB","sourcesContent":[".uploader__main {\n  width: 100%;\n  height: 280px;\n  display: flex;\n  justify-content: space-between;\n  position: relative;\n  background-color: #fff;\n  overflow: hidden;\n}\n\n.uploader__main__loader {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: #fff;\n  z-index: 10;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  display: none;\n}\n\n.uploader__main__loader.visible {\n  display: flex;\n}\n\n.uploader__main__dropper {\n  width: 60%;\n  height: 100%;\n  border: 1px dashed rgb(208, 208, 208);\n  border-radius: 5px;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.uploader__main__dropper__container {\n  padding: 10px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  pointer-events: none;\n}\n\n.uploader__main__dropper__container.enable {\n  pointer-events: all;\n}\n\n.uploader__main__sample {\n  width: 150.4px;\n  height: auto;\n}\n\n.uploader__main__sample__image {\n  height: 145.6px;\n  width: 150.4px;\n  overflow: hidden;\n}\n\n.uploader__main__sample__image img {\n  width: 100%;\n}\n\n.uploader__bottom {\n  width: 100%;\n  height: 60px;\n  display: flex;\n  justify-content: flex-end;\n  align-items: flex-end;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
